import { takeLatest, call, put } from 'redux-saga/effects'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../actions/courses.action'
import exportReport, {
  exportBasicReport,
} from '../../../api/courses/exportReport'

async function handleIndividualDownloadCourse({
  courseId,
  filters,
  onlyGeneralInfo,
}) {
  return exportReport(courseId, {
    filters,
    onlyGeneralInfo,
  })
}

async function handleBasicReportDownloadCourse({ courseId, filters }) {
  return exportBasicReport(courseId, {
    filters,
  })
}

function* coursesDownloadEffectSaga({
  payload,
}: fromActions.CoursesIndividualDownloadAction) {
  try {
    const { courseId, filters, onlyGeneralInfo } = payload

    const { data } = yield call(handleIndividualDownloadCourse, {
      courseId,
      filters,
      onlyGeneralInfo,
    })
    yield put(fromActions.Actions.coursesIndividualDownloadSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.downSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.downloadError'))
    console.error(error)
  }
}

function* coursesBasicReportDownloadEffectSaga({
  payload,
}: fromActions.CoursesIndividualDownloadAction) {
  try {
    const { courseId, filters } = payload

    const { data } = yield call(handleBasicReportDownloadCourse, {
      courseId,
      filters,
    })
    yield put(fromActions.Actions.coursesIndividualDownloadSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.downSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.downloadError'))
    console.error(error)
  }
}

export function* coursesIndividualDownloadWatcherSaga() {
  yield takeLatest(
    fromActions.COURSES_INDIVIDUAL_DOWNLOAD,
    coursesDownloadEffectSaga
  )
  yield takeLatest(
    fromActions.COURSES_BASIC_REPORT_DOWNLOAD,
    coursesBasicReportDownloadEffectSaga
  )
}
